import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-56a95795")

_pushScopeId("data-v-56a95795")
const _hoisted_1 = { class: "order-item" }
const _hoisted_2 = { class: "order--detail" }
const _hoisted_3 = { class: "order--category -bold" }
const _hoisted_4 = { class: "p-mb-2" }
const _hoisted_5 = { class: "order--action" }
const _hoisted_6 = { class: "p-mb-2" }
const _hoisted_7 = {
  key: 0,
  class: "order--more"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Card = _resolveComponent("Card")
  const _component_OrderList = _resolveComponent("OrderList")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_OrderList, {
      modelValue: _ctx.state.list,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.list = $event)),
      listStyle: "height:auto",
      dataKey: "requestKey",
      selection: _ctx.state.selection,
      "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.selection = $event))
    }, {
      item: _withId((slotProps) => [
        _createVNode(_component_Card, null, {
          content: _withId(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("h6", _hoisted_3, _toDisplayString(slotProps.item.category), 1),
                _createVNode("span", _hoisted_4, _toDisplayString(slotProps.item.paymentDate) + " | " + _toDisplayString(slotProps.item.doctorName), 1)
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("h6", _hoisted_6, "$" + _toDisplayString(slotProps.item.price), 1),
                _createVNode("span", null, _toDisplayString(slotProps.item.requestStatus), 1)
              ])
            ])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["modelValue", "selection"]),
    (_ctx.isLastOne)
      ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.t("more")), 1))
      : _createCommentVNode("", true)
  ], 64))
})